import React, { useCallback } from 'react';
import DawidHeader from '../header.jsx';
import { useFlowStore, useUiStore, useFlowRegistry } from '../../store/react';

const WITH_CENTER_COLUMN = 10;

export default function HeaderWrapper() {
    const registry = useFlowRegistry();
    const flow = useFlowStore((s) => registry.get(s.currentFlowId));
    const resetFlow = useFlowStore((s) => s.reset);
    const clearContract = useUiStore((s) => s.clearContract);
    const resetSession = useCallback(
        () => { clearContract(); resetFlow(); },
        [clearContract, resetFlow],
    );
    return (
        <DawidHeader
            width={WITH_CENTER_COLUMN}
            logo={flow?.logo}
            resetSession={resetSession}
        />
    );
}
